/* Tosca Infinity Set – show VERSION INFO only for keyboard-linked purchase. */
(() => {
  if (window.__toscaInfinityChoiceInitialized) return;
  window.__toscaInfinityChoiceInitialized = true;

  const selector = 'select[data-tosca-protection-choice], input[data-tosca-infinity-variant]';

  function syncForm(form) {
    if (!form) return;
    const input = form.querySelector(selector);
    const panel = form.querySelector('[data-tosca-keyboard-details]');
    if (!input || !panel) return;

    const keyboardVariantId = panel.dataset.keyboardVariantId;
    const isKeyboard = Boolean(keyboardVariantId && input.value === keyboardVariantId);
    panel.hidden = !isKeyboard;
    panel.querySelectorAll('input[type="file"]').forEach(photo => {
      photo.disabled = !isKeyboard;
      if (!isKeyboard) photo.value = '';
    });
  }

  function syncAll(root = document) {
    root.querySelectorAll(selector).forEach(input => syncForm(input.closest('form')));
  }

  document.addEventListener('change', event => {
    if (event.target?.matches?.(selector)) syncForm(event.target.closest('form'));
  });
  document.addEventListener('shopify:section:load', event => syncAll(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncAll(), { once: true });
  } else {
    syncAll();
  }
})();
